/* eslint-disable */
import { connect } from 'react-redux';
import { modalActions } from '../../../../Actions';
import { modalTypes } from '../../../../Constants';
import AddProductCard from '../../AddProductCard';
// import ProductCard from '../../ProductCard';
import styles from './RecipeCustomizationSKUs.module.scss';
import RecipeProductCard from '../CookingRecipeProductCard/RecipeProductCard';

// Ingredient type tag on the recipe ingredient cards.
const SKU_TYPE_BADGES = {
	INTERMEDIATE: { text: 'SFG', title: 'Semi-finished good (Intermediate)', className: 'bg-amber-600' },
	INGREDIENT: { text: 'RM', title: 'Raw material (Ingredient)', className: 'bg-sky-700' },
};
import { CustomizationSKU } from '../../Customizations/CustomizationSKU';
import { alterProductForSalesUnitConsumptionLogic, isSalesUnitConsumptionLogicTrue } from '@/Helpers';

const RecipeCustomizationSKUs = (props) => {
	const {
		id,
		skus,
		toggleProductVariants,
		isDisabled,
		selectedSkus,
		handleDelete,
		applicableOn,
		customizationType,
		deltaPricing,
		mandatoryFields,
		handleInput,
		showVariants,
		allVariants,
		defaultVariant,
		checkApplicability,
		extraProps,
		fallbackText,
		activePastCustomizationValue,
	} = props;

	// Build diff map for SKUs
	const skuDiffMap = {};
	if (activePastCustomizationValue?.skus) {
		activePastCustomizationValue.skus.forEach((pastSku) => {
			skuDiffMap[pastSku.skuId] = { ...pastSku, status: 'removed' };
		});
	}

	const openSKUs = () => {
		toggleProductVariants(true, {
			groupId: id,
			itemTypes: [
				'PRODUCT',
				'INTERMEDIATE',
				'UNPACKED_PRODUCT',
				'INGREDIENT',
				'PACKAGING',
				'OTHER',
			],
		});
	};

	const renderSkuCard = (skuData, isPast = false, idx = null) => {
		let sku = skus?.[skuData?.skuId] ?? null;
		if (isSalesUnitConsumptionLogicTrue(sku)) {
			sku = alterProductForSalesUnitConsumptionLogic(sku);
		}
		if (!sku) return null;

		const skuVariant = sku.ProductVariant[skuData.variantId];
		const pastSku = isPast ? null : skuDiffMap[skuData.skuId];
		const isNew = !isPast && activePastCustomizationValue && !pastSku;
		const isChanged = !isPast && pastSku && (
			JSON.stringify(skuData.variants) !== JSON.stringify(pastSku.variants) ||
			String(skuData.containerWeight ?? '') !== String(pastSku.containerWeight ?? '')
		);
		const isRemoved = isPast;

		// If it's in the current list, mark it as processed in the diff map
		if (!isPast && pastSku) {
			skuDiffMap[skuData.skuId].status = 'matched';
		}

		const rowKey = isPast
			? `past-${skuData.id ?? skuData.skuId}-${skuData.variantId}`
			: `sku-${skuData.id ?? 'new'}-${skuData.variantId}-${idx}`;

		return (
			<div
				key={rowKey}
				className={`relative transition-all duration-300 ${isNew ? 'ring-2 ring-green-500 rounded-xl bg-green-50' :
					isRemoved ? 'ring-2 ring-red-500 rounded-xl opacity-70 bg-red-50 grayscale' :
						isChanged ? 'ring-2 ring-amber-500 rounded-xl bg-amber-50' : ''
					}`}
			>
				{isNew && (
					<span className='absolute top-0 left-2 z-10 text-[10px] bg-green-500 text-white px-1.5 py-0.5 rounded font-bold shadow-sm'>NEW</span>
				)}
				{isRemoved && (
					<span className='absolute top-0 left-2 z-10 text-[10px] bg-red-500 text-white px-1.5 py-0.5 rounded font-bold shadow-sm'>REMOVED</span>
				)}
				{isChanged && (
					<span className='absolute top-0 left-2 z-10 text-[10px] bg-amber-500 text-white px-1.5 py-0.5 rounded font-bold shadow-sm'>CHANGED</span>
				)}

				<RecipeProductCard
					key={`${rowKey}-card`}
					title={`${sku.productName}\n(${skuVariant?.displayName ?? '-'})`}
					img={sku.productImageUrl}
					idx={idx}
					handleDelete={handleDelete}
					dataAttrs={{
						'data-type': 'sku',
						'data-id': idx,
						'data-parent': id,
					}}
					isDisabled={isDisabled || isRemoved}
					badge={SKU_TYPE_BADGES[sku.skuType ?? skuData.skuType] ?? null}
				>
					<CustomizationSKU
						id={id}
						key={`${rowKey}-sku`}
						idx={idx}
						sku={skuData}
						variant={skuVariant}
						applicableOn={applicableOn}
						allVariants={allVariants}
						customizationType={customizationType}
						deltaPricing={deltaPricing}
						mandatoryFields={mandatoryFields}
						handleInput={handleInput}
						showVariants={showVariants}
						checkApplicability={checkApplicability}
						defaultVariant={defaultVariant}
						extraProps={{
							...extraProps,
							pastSkuData: pastSku,
						}}
						isDisabled={isDisabled || isRemoved}
					/>
				</RecipeProductCard>
			</div>
		);
	};

	return (
		<div className={styles.root}>
			{showVariants && selectedSkus.length > 0 && (
				<div
					className={`${styles['applicable-variants']} ${selectedSkus.length === 0 ? styles.hidden : ''
						} ${deltaPricing ? '' : styles['not-delta-pricing']}`}
				>
					{(extraProps.skuMeta?.variants ||
						customizationType !== 'REMOVABLE') &&
						applicableOn
							?.filter((variant) => {
								if (checkApplicability) {
									return variant.isApplied;
								}
								return true;
							})
							.map((variant, idx) => {
								return (
									<div
										className={
											styles['variant-tile-wrapper']
										}
										key={variant.id}
									>
										<span
											className={styles['variant-tile']}
										>
											{variant.name}
										</span>
										<span className={styles['svng-bs']}>
											<p>
												{
													allVariants?.[idx]
														?.servingQtyPercentage
												}
												%
											</p>
											<p>
												{allVariants?.[idx]?.batchSize}
											</p>
										</span>
									</div>
								);
							})}
					<div className={styles.filler} />
				</div>
			)}
			<div className={styles['skus-wrapper']}>
				{selectedSkus.map((currSelectedSku, idx) => renderSkuCard(currSelectedSku, false, idx))}

				{/* Items that were in the past version but are missing now (Removed) */}
				{Object.values(skuDiffMap)
					.filter(item => item.status === 'removed')
					.map(pastSku => renderSkuCard(pastSku, true))}

				{selectedSkus.length === 0 && Object.values(skuDiffMap).filter(item => item.status === 'removed').length === 0 && (
					<p className={styles.fallback}>{fallbackText}</p>
				)}

				{!isDisabled && (
					<AddProductCard
						className='w-[210px] h-[150px] min-w-[210px] max-w-[210px] rounded-xl py-0'
						text='SKU'
						handleClick={openSKUs}
					/>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const skus = state.product.products;
	return {
		skus,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		toggleProductVariants: (show, data = {}) => {
			dispatch(
				modalActions.toggleModal(
					modalTypes.PRODUCT_VARIANTS,
					show,
					data
				)
			);
		},
	};
};

RecipeCustomizationSKUs.defaultProps = {
	showVariants: true,
	checkApplicability: true,
	extraProps: {},
	fallbackText: 'No ingredients added',
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RecipeCustomizationSKUs);
